/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">企業管理者画面</div>
            <div class="store_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
                <form class="form_checkSetting">

                    <div class="wd400">
                        <p v-if="this.viewtype== 'TOP'" class="checkSetting_text">TOPメニュー画面 {{this.buttonname}}</p>
                        <p v-else-if="this.viewtype== 'day1'" class="checkSetting_text">TOPボタンA メニュー画面 {{this.buttonname}}</p>
                        <p v-else-if="this.viewtype== 'day2'" class="checkSetting_text">TOPボタンD メニュー画面 {{this.buttonname}}</p>
                        <p v-else-if="this.viewtype== 'ImCheck'" class="checkSetting_text">TOPメニューボタンB メニュー画面 {{this.buttonname}}</p>
                    </div><br>

                    <div class="wd720">
                        <Message v-if="ApivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                        <Message v-if="ApivalidationMessage" :validationMessage="ApivalidationMessage" />
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="displaySet">表示設定</label>
                    </div>
                    <div v-if="this.viewtype== 'TOP' || this.viewtype== 'day1' || this.viewtype== 'day2'" class="input_store left_comment" id="displaySet">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="displaySet_id1" name="checkdis" type="radio" value='1' v-model="checkPageSetting.displayFlg">
                            <label class="form-check-label" for="displaySet_id1">表示</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="displaySet_id2" name="checkdis" type="radio" value='0' v-model="checkPageSetting.displayFlg">
                            <label class="form-check-label" for="displaySet_id2">非表示</label>
                        </div>
                        <br>
                        <label id="displaySet_id_err1" class="lavel_error_font ">{{validation.displayFlgResult}}</label>
                    </div>
                    <div v-if="this.viewtype== 'ImCheck'" class="input_store left_comment">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="displaySet_Check_id1" name="checkdis" type="radio" value='1' v-model="foodGroupSetting.displayFlg">
                            <label class="form-check-label" for="displaySet_Check_id1">表示</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="displaySet_Check_id2" name="checkdis" type="radio" value='0' v-model="foodGroupSetting.displayFlg">
                            <label class="form-check-label" for="displaySet_Check_id2">非表示</label>
                        </div>
                        <br><label id="displaySet_id_err2" class="lavel_error_font ">{{validation.displayFlgResult}}</label>
                    </div>

                    <div v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" class="lavel_store right_comment">
                        <img v-if="checkPageSetting.displayFlg == 1 || foodGroupSetting.displayFlg == 1" class="required" src="../assets/required.png" />
                        <label for="button_name">ボタン名称</label>
                    </div>
                    <div v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" class="input_store left_comment">
                        <input class="wd400"  id="button_name" name="buttonname" type="text" v-model="checkPageSetting.dailyCheckButtonName" maxlength="30"/><br>
                        <label id="button_name_err" class="lavel_error_font ">{{validation.buttonNameResult}}</label>
                    </div>

                    <div v-if="this.viewtype== 'TOP' || this.viewtype== 'ImCheck'" class="lavel_store right_comment">
                        <img v-if="checkPageSetting.displayFlg == 1 || foodGroupSetting.displayFlg == 1" class="required" src="../assets/required.png" />
                        <label for="button_name_Up">ボタン名称(上段)</label>
                    </div>
                    <div v-if="this.viewtype== 'TOP'" class="input_store left_comment" id="button_name_Up">
                        <input class="wd400" name="buttonnameUp" type="text" v-model="checkPageSetting.upperButtonName" maxlength="30"/><br>
                        <label id="button_name_Up_err1" class="lavel_error_font ">{{validation.upperButtonNameResult}}</label>
                    </div>
                    <div v-if="this.viewtype== 'ImCheck'" class="input_store left_comment">
                        <input class="wd400" name="buttonnameUp" type="text" v-model="foodGroupSetting.upperButtonName" maxlength="30"/><br>
                        <label id="button_name_Up_err2" class="lavel_error_font ">{{validation.upperButtonNameResult}}</label>
                    </div>

                    <div v-if="this.viewtype== 'TOP' || this.viewtype== 'ImCheck'" class="lavel_store right_comment">
                        <img v-if="checkPageSetting.displayFlg == 1 || foodGroupSetting.displayFlg == 1" class="required" src="../assets/required.png" />
                        <label for="button_name_dw">ボタン名称(下段)</label>
                    </div>
                    <div v-if="this.viewtype== 'TOP'" class="input_store left_comment" id="button_name_dw">
                        <input class="wd400" name="buttonnamedw" type="text" v-model="checkPageSetting.lowerButtonName" maxlength="22"/><br>
                        <label id="button_name_dw_err1" class="lavel_error_font ">{{validation.lowerButtonNameResult}}</label>
                    </div>
                    <div v-if="this.viewtype== 'ImCheck'" class="input_store left_comment">
                        <input class="wd400" name="buttonnamedw" type="text" v-model="foodGroupSetting.lowerButtonName" maxlength="22"/><br>
                        <label id="button_name_dw_err2" class="lavel_error_font ">{{validation.lowerButtonNameResult}}</label>
                    </div>


                    <div v-if="(this.viewtype== 'TOP' && this.bottunid== 3) || this.viewtype== 'ImCheck'" class="lavel_check_setting right_comment ">
                        <label for="manual">マニュアル</label>
                    </div>
                    <div v-if="(this.viewtype== 'TOP' && this.bottunid== 3)" class="input_store left_comment selectFile" id="manual">
                        <input v-if="this.manualFile == null" class="wd400" name="manual1" type="text" disabled />
                        <input v-if="this.manualFile !== null" class="wd400" name="manual2" type="text" disabled v-model="manualFile['name']" />
                        <label class="selectFile__label">選択<input ref="manual" type="file" accept="image/jpeg, image/jpg, image/png, image/gif,.pdf" @change="selectManualFiles($event)">
                        </label>
                        <p id="manual_fill_name1" class="wd400 text_white_space_nowrap" style="display: inline-flex;">{{checkPageSetting.healthCheckPageSettings.manualFilePath}}</p>
                        <label v-if="checkPageSetting.healthCheckPageSettings.manualFilePath" class="selectFile__label" @click.prevent.stop="openDeleteModal(1)">削除</label><br>
                        <p id="manual_err1" class="lavel_error_font ">{{validation.manualFilePathResult}}</p>
                    </div>
                    <div v-if="this.viewtype== 'ImCheck'" class="input_store left_comment selectFile">
                        <input v-if="this.manualFile == null" class="wd400" id="manual3" name="manual" type="text" disabled />
                        <input v-if="this.manualFile !== null" class="wd400" id="manual24" name="manual" type="text" disabled v-model="manualFile['name']" />
                        <label class="selectFile__label">選択<input ref="manual" type="file" accept="image/jpeg, image/jpg, image/png, image/gif,.pdf" @change="selectManualFiles($event)">
                        </label>
                        <p id="manual_fill_name2" class="wd400 text_white_space_nowrap" style="display: inline-flex;">{{foodGroupSetting.manualFilePath}}</p>
                        <label v-if="foodGroupSetting.manualFilePath" class="selectFile__label" @click.prevent.stop="openDeleteModal(1)">削除</label><br>
                        <p id="manual_err2" class="lavel_error_font ">{{validation.manualFilePathResult}}</p>
                    </div>


                    <div v-if="(this.viewtype== 'TOP' && this.bottunid== 3) || this.viewtype== 'ImCheck'" class="lavel_check_setting right_comment">
                        <label for="information">インフォメーション</label>
                    </div>
                    <div v-if="(this.viewtype== 'TOP' && this.bottunid== 3)" class="input_store left_comment selectFile" id="information">
                        <input v-if="this.informationFile == null" class="wd400" name="information" type="text" disabled  />
                        <input v-if="this.informationFile !== null" class="wd400" name="information" type="text" disabled v-model="informationFile['name']" />
                        <label class="selectFile__label">選択<input ref="information" type="file" accept="image/jpeg, image/jpg, image/png, image/gif,.pdf" @change="selectInfoFiles($event)">
                        </label>
                        <p id="info_fill_name1" class="wd400 text_white_space_nowrap" style="display: inline-flex;">{{checkPageSetting.healthCheckPageSettings.informationFilePath}}</p>
                        <label v-if="checkPageSetting.healthCheckPageSettings.informationFilePath" class="selectFile__label" @click.prevent.stop="openDeleteModal(2)">削除</label><br>
                        <p id="information_err1" class="lavel_error_font ">{{validation.informationFilePathResult}}</p>
                        <p>※マニュアル、インフォメーションについて画像(jpeg,jpg,png,gif)またはpdfのみ許可</p>
                        <p>※アップロードできるファイルサイズは500MBまでです</p>
                    </div>
                    <div v-if="viewtype== 'ImCheck'" class="input_store left_comment selectFile">
                        <input v-if="this.informationFile == null" class="wd400" name="information" type="text" disabled  />
                        <input v-if="this.informationFile !== null" class="wd400" name="information" type="text" disabled v-model="informationFile['name']" />
                        <label class="selectFile__label">選択<input ref="information" type="file" accept="image/jpeg, image/jpg, image/png, image/gif,.pdf" @change="selectInfoFiles($event)">
                        </label>
                        <p id="info_fill_name2" class="wd400 text_white_space_nowrap" style="display: inline-flex;">{{foodGroupSetting.informationFilePath}}</p>
                        <label v-if="foodGroupSetting.informationFilePath" class="selectFile__label" @click.prevent.stop="openDeleteModal(2)">削除</label><br>
                        <p id="information_err2" class="lavel_error_font ">{{validation.informationFilePathResult}}</p>
                        <p>※マニュアル、インフォメーションについて画像(jpeg,jpg,png,gif)またはpdfのみ許可</p>
                        <p>※アップロードできるファイルサイズは500MBまでです</p>
                    </div>

                    <div v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" class="lavel_store right_comment">
                        <label>ページ設定</label>
                    </div>
                    <div  v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" style="padding: 15px" id="pageSetting" name="pageSetting" >
                        <table class="checkSetting_tbl_unit">
                            <tbody>
                                <tr>
                                    <th class="wd70">ページ<br>No</th>
                                    <th class="wd140 tbl_tex_center">タイトル</th>
                                    <th class="wd140 tbl_tex_center" >マニュアル</th>
                                    <th class="wd140 tbl_tex_center">インフォメーション</th>
                                    <th class="wd70">表示</th>
                                    <th class="wd70">設定<br>項目数</th>
                                    <th class="wd70">編集</th>
                                </tr>
                                <tr v-for="dailyCheckSettingList in dailyCheckSettingLists" :key="dailyCheckSettingList.dailyCheckPageNo" class="checkSetting_text_height">
                                    <td class="text_white_space checkSetting_text_align">{{dailyCheckSettingList.dailyCheckPageNo}}</td>
                                    <td class="text_white_space">{{dailyCheckSettingList.dailyCheckPageName}}</td>
                                    <td class="text_white_space">{{dailyCheckSettingList.manualFilePath}}</td>
                                    <td class="text_white_space">{{dailyCheckSettingList.informationFilePath}}</td>
                                    <td class="checkSetting_text_align">{{dailyCheckSettingList.displayStr}}</td>
                                    <td class="checkSetting_text_align">{{dailyCheckSettingList.dailyCheckItemCount}}/50</td>
                                    <td class=" checkSetting_buttan_unit checkSetting_kanri_box checkSetting_text_align">
                                        <ul class="ul_tbl_buttan">
                                            <li>
                                                <router-link
                                                    @click.native="setDailyCheckSetting(dailyCheckSettingList.dailyCheckPageId, dailyCheckSettingList.dailyCheckPageNo)"
                                                    :to="{ name: 'manageCheckViewSettingPage' , params:{ page:dailyCheckSettingList.dailyCheckPageNo }}">
                                                    編集</router-link>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="this.viewtype== 'ImCheck'" class="lavel_store right_comment">
                        <label>ヘッダー設定</label>
                    </div>
                    <div v-if="this.viewtype== 'ImCheck'" style="padding: 15px" id="pageSettingCooking" name="pageSetting" >
                        <table class="checkSetting_tbl_unit">
                            <tbody>
                                <tr>
                                    <th class="wd70">表示順</th>
                                    <th class="wd250 tbl_tex_center">ヘッダー上段</th>
                                    <th class="wd250 tbl_tex_center" >ヘッダー下段</th>
                                    <th class="wd100 tbl_tex_center">表示設定</th>
                                </tr>
                                <tr v-for="(foodGroupSettingList, index) in foodGroupSettingLists" :key="foodGroupSettingList.cookingCheckHeaderId" class="checkSetting_text_height">
                                    <td class="checkSetting_text_align">{{foodGroupSettingList.cookingCheckHeaderNo}}</td>

                                    <td v-if="bottunid== 1 || bottunid== 2 || bottunid== 3" style="background-color: #888"></td>
                                    <td v-else-if="(bottunid== 4 && foodGroupSettingList.itemId == 1)" style="background-color: #888"></td>
                                    <td v-else-if="(bottunid== 5 && foodGroupSettingList.itemId == 1)" style="background-color: #888"></td>
                                    <td v-else-if="(bottunid== 4 && foodGroupSettingList.itemId == 2)" rowspan="5">
                                        <input type="text" class="textbox_td_Settting" v-model="foodGroupSettingList.upperButtonName" maxlength="30"
                                               @change="chengeHeaderUpper($event,bottunid,foodGroupSettingList.itemId)"></td>
                                    <td v-else-if="(bottunid== 4 && foodGroupSettingList.itemId == 8)" rowspan="5">
                                        <input type="text" class="textbox_td_Settting" v-model="foodGroupSettingList.upperButtonName" maxlength="30"
                                               @change="chengeHeaderUpper($event,bottunid,foodGroupSettingList.itemId)"></td>
                                    <td v-else-if="(bottunid== 5 && foodGroupSettingList.itemId == 2)" rowspan="5">
                                        <input type="text" class="textbox_td_Settting" v-model="foodGroupSettingList.upperButtonName" maxlength="30"
                                               @change="chengeHeaderUpper($event,bottunid,foodGroupSettingList.itemId)"></td>
                                    <td v-else-if="(bottunid== 4 && foodGroupSettingList.itemId == 7)">
                                        <input type="text" class="textbox_td_Settting" v-model="foodGroupSettingList.upperButtonName" maxlength="30"></td>
                                    <td v-else-if="(bottunid== 5 && foodGroupSettingList.itemId == 7)">
                                        <input type="text" class="textbox_td_Settting" v-model="foodGroupSettingList.upperButtonName" maxlength="30"></td>
                                    <td v-else-if="(bottunid== 5 && foodGroupSettingList.itemId == 8)" rowspan="3">
                                        <input type="text" class="textbox_td_Settting" v-model="foodGroupSettingList.upperButtonName" maxlength="30"
                                               @change="chengeHeaderUpper($event,bottunid,foodGroupSettingList.itemId)"></td>
                                    <td v-else-if="(bottunid== 4 && foodGroupSettingList.itemId >= 13)" style="background-color: #888"></td>
                                    <td v-else-if="(bottunid== 5 && foodGroupSettingList.itemId >= 11)" style="background-color: #888"></td>
                                    <td><input type="text" class="textbox_td_Settting"  v-model="foodGroupSettingList.lowerButtonName" maxlength="30"></td>

                                    <td class="checkSetting_text_align">
                                        <a href="#" role="button" v-if="foodGroupSettingList.displayFlg == true"
                                           v-on:click.prevent.stop="clickChech($event,index)" :id="'hd_' +foodGroupSettingList.cookingCheckHeaderId">
                                            <p class="icn_blue_td"><i class="far fa-circle"></i></p></a>
                                        <a href="#" role="button" v-else-if="foodGroupSettingList.displayFlg == false" v-on:click.prevent.stop="clickChech($event,index)">
                                            <p class="icn_red_td"><i class="fas fa-times"></i></p></a>
                                        <a href="#" role="button" v-else v-on:click.prevent.stop="clickChech($event,index)">
                                            <p class="icn_white_td"><i class="far fa-circle"></i></p></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div><br>
                    <div v-if="bottunid== 3 && this.viewtype== 'TOP'" class="lavel_store right_comment">
                      <label>チェック項目設定</label>
                    </div>
                    <div v-if="bottunid== 3 && this.viewtype== 'TOP'" class="admin_button_top_unit mgl_10" id="healthCheckSeting">
                      <div class="checkSetting_buttan_unit ">
                        <div class="checkSetting_kanri_box ">
                          <ul class="ul_tbl_buttan"><li>
                            <router-link
                              :to="{ name: 'manageHealthCheckViewSetting'}">
                            編集</router-link></li></ul>
                        </div>
                      </div>
                    </div>
                    <div v-if="bottunid== 3 && this.viewtype== 'TOP'" class="lavel_store right_comment">
                        <label>チェックアラート設定</label>
                    </div>
                    <div v-if="bottunid== 3 && this.viewtype== 'TOP'" class="input_store left_comment" id="checkAlertSet">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="checkAlertSet_id1" type="radio" value='1' v-model="checkPageSetting.healthCheckPageSettings.checkAlert">
                            <label class="form-check-label" for="checkAlertSet_id1">有</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="checkAlertSet_id2" type="radio" value='0' v-model="checkPageSetting.healthCheckPageSettings.checkAlert">
                            <label class="form-check-label" for="checkAlertSet_id2">無</label>
                        </div>
                        <br>
                        <label id="checkAlertSet_id_err1" class="lavel_error_font ">{{validation.checkAlertResult}}</label>
                    </div>
                    <label id="header_coment_err" class="lavel_error_font ">{{validation.headerSettingResult}}</label>

                    <div v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" class="lavel_store right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label for="free_comment">フリーコメント</label>
                    </div>
                    <div v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" class="input_store left_comment">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="free_comment" name="freecheckdis" type="radio" value='1' :checked="this.checkPageSetting.freeCommentFlg == true">
                            <label class="form-check-label" for="free_comment">表示</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="free_comment2" name="freecheckdis" type="radio"  value='0' :checked="this.checkPageSetting.freeCommentFlg == false">
                            <label class="form-check-label" for="free_comment2">非表示</label>
                        </div>
                        <br>
                        <label id="free_coment_err" class="lavel_error_font ">{{validation.freeCommentFlgResult}}</label>
                    </div>
                </form><br>
            </div>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li>
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="cancel">キャンセル</a></li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="openModel">更新</a></li>
                    </ul>
                    <ul v-if="preview.button1.display" class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit btn_preview_color" href="#" @click.prevent.stop="openPreview(preview.button1.prefix)">{{ preview.button1.name }}</a></li>
                    </ul>
                    <ul v-if="foodGroupSetting.displayFlg == 1" class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit btn_preview_color" href="#" @click.prevent.stop="openPreview(preview.button2.prefix)">{{ preview.button2.name }}</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s">チェック内容設定編集</p>
                            <p v-if="this.viewtype== 'TOP'" class="checkSetting_text">TOPメニュー画面 {{this.buttonname}}</p>
                            <p v-else-if="this.viewtype== 'day1'" class="checkSetting_text">TOPボタンA メニュー画面 {{this.buttonname}}</p>
                            <p v-else-if="this.viewtype== 'day2'" class="checkSetting_text">TOPボタンD メニュー画面 {{this.buttonname}}</p>
                            <p v-else-if="this.viewtype== 'ImCheck'" class="checkSetting_text">TOPボタンB メニュー画面 {{this.buttonname}}</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>チェック内容設定編集の更新が<br>
                            が完了しました。</p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModel">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
        <div class="overlay" v-show="showDeleteContent1">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">{{deleteFileName}}削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>{{deleteFileName}}を削除しますか？
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeDeleteModal1">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="deleteFile">削除</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showDeleteContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">{{deleteFileName}}削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>{{deleteFileName}}削除が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeDeleteModal2">OK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'

export default {
    name: 'CheckViewSetting',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            isLoading:false,
            isInitLoading:true,
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            validation:{
                displayFlgResult:"",
                buttonNameResult:"",
                upperButtonNameResult:"",
                lowerButtonNameResult:"",
                manualFilePathResult:"",
                informationFilePathResult:"",
                freeCommentFlgResult:"",
                headerSettingResult:"",
                checkAlertResult:"",
            },
            brandId: '',
            manualFile: null,
            informationFile: null,
            count:20,
            cookingCheckItemCount1:25,
            cookingCheckItemCount2:29,
            cookingCheckItemCount3:32,
            cookingCheckItemCount4:30,
            showContent:false,
            dailyCheckSettingLists:[
                {   dailyCheckPageId:null,
                    dailyCheckPageNo:0,
                    dailyCheckPageName:'',
                    manualFilePath:'',
                    informationFilePath:'',
                    displayFlg:null,
                    displayStr:'',
                    dailyCheckItemCount:null
                }
            ],
            foodGroupSettingLists:[],
            checkPageSetting:{
                displayFlg: null,
                healthCheckPageSettings: {
                    manualFilePath:'',
                    informationFilePath:'',
                    checkAlert:0,
                }
            },
            foodGroupSetting: {
                displayFlg: null
            },
            addFormFlg: true,
            preview: {
                button1: {
                    prefix: 'Index',
                    display: false,
                    name: '',
                },
                button2: {
                    prefix: 'Input',
                    display: false,
                    name: '',
                }
            },
            showDeleteContent1: false,
            showDeleteContent2: false,
            deleteFileType: 0,
            deleteFileName: "",
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        id: function () {
            return this.$store.getters['checkPage/id']
        },
        viewtype: function () {
            return this.$store.getters['checkPage/viewType']
        },
        bottunid: function () {
            return this.$store.getters['checkPage/buttonId']
        },
        menuid: function () {
            return this.$store.getters['checkPage/menuId']
        },
        buttonname: function () {
            return this.$store.getters['checkPage/buttonName']
        },
        buttonno: function () {
            return this.$store.getters['checkPage/buttonNo']
        },
    },
    created: async function(){
        await this.calc();
        this.setPreviewButton();
    },
    methods:{
        async calc(){

            var apiResponseFlg = true;

            // 企業ブランドIDの取得
            this.brandId = this.$store.getters['brand/id']
            // 当日日付取得
            var currentTime = this.getCurrentTime();
            if (this.viewtype == 'ImCheck') {

                // 重要管理項目メニュー設定取得API
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/cooking_check/' + this.id, { params: { datetime: currentTime}})
                    .then(response => (this.foodGroupSetting = response.data.foodGroupSetting))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

                if(apiResponseFlg){
                    this.foodGroupSettingData();
                }
            }
            else if(this.viewtype == 'TOP') {

                // メニューページ設定概要取得API
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/' + this.id + '/page', { params: { datetime: currentTime } })
                    .then(response => (this.checkPageSetting = response.data))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);
            }
            else{

                var topButtonId = this.menuid
                // メニューページ設定概要取得API
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/' + topButtonId + '/page', {
                        params: {
                            datetime: currentTime,
                            daily_check_button_id: this.id
                        }})
                    .then(response => (this.checkPageSetting = response.data))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

                if(apiResponseFlg){
                    this.dailySettingData();
                }
            }

        },
        setPreviewButton() {
            let name = 'プレビュー';
            switch (this.viewtype) {
                case 'TOP':
                case 'day1':
                case 'day2':
                    this.preview.button1.display = true;
                    this.preview.button1.name = name;
                    break;
                case 'ImCheck':
                    this.preview.button1.display = true;
                    this.preview.button1.name = 'ボタン名称' + name;
                    this.preview.button2.display = true;
                    this.preview.button2.name = 'ヘッダー設定'+ name;
                    break;
                default:
                    break;
            }
        },
        openPreview(prefix) {
            this.isLoading = true;

            // バリデーションチェック
            this.validationCheck();
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }
            this.$store.dispatch('preview/doClear')
            this.$store.dispatch('preview/setPreviewInfo', this.getPreviewInfo());

            //別タブ表示
            let routeData = this.$router.resolve({name: this.getPreviewPageName(prefix), params: this.getPreviewParams()});
            window.open(routeData.href, '_blank');
            this.isLoading = false;
        },
        getPreviewInfo() {
            let previewInfo = {};

            switch (this.viewtype) {
                case 'TOP':
                    //TOPメニュー画面の設定
                    previewInfo.upperButtonName = this.checkPageSetting.upperButtonName;
                    previewInfo.lowerButtonName = this.checkPageSetting.lowerButtonName;
                    previewInfo.displayFlg = this.checkPageSetting.displayFlg;
                    break;
                case 'day1':
                case 'day2':
                    //店舗チェック画面の設定
                    previewInfo.dailyCheckButtonName = this.checkPageSetting.dailyCheckButtonName;
                    previewInfo.displayFlg = this.checkPageSetting.displayFlg;
                    break;
                case 'ImCheck':
                    //調理確認画面の設定
                    previewInfo.upperButtonName = this.foodGroupSetting.upperButtonName;
                    previewInfo.lowerButtonName = this.foodGroupSetting.lowerButtonName;
                    previewInfo.displayFlg = this.foodGroupSetting.displayFlg;

                    var headerItemList = [];
                    this.foodGroupSettingLists.forEach(headerItem => {
                        headerItemList.push({
                            cookingCheckHeaderId: headerItem.cookingCheckHeaderId,
                            upperButtonName: headerItem.upperButtonName,
                            lowerButtonName: headerItem.lowerButtonName,
                            displayFlg: headerItem.displayFlg,
                        });
                    });
                    previewInfo.headerItemList = headerItemList;

                    break;
                default:
                    break;
            }
            return previewInfo;
        },
        getPreviewPageName (prefix) {
            let viewName = '';
            switch (this.viewtype) {
                case 'TOP':
                    viewName = 'topPreview';
                    break;
                case 'day1':
                case 'day2':
                    viewName = 'dailyCheckMenu' + prefix + 'Preview';
                    break;
                case 'ImCheck':
                    viewName = 'cookingCheck' + prefix + 'Preview';
                    break;
                default:
                    break;
            }
            return viewName;
        },
        getPreviewParams () {
            let params = {};
            switch (this.viewtype) {
                case 'TOP':
                    break;
                case 'day1':
                case 'day2':
                    params = { menuId: this.menuid };
                    break;
                case 'ImCheck':
                    params = { menuId: this.menuid, subMenuId: this.id };
                    break;
                default:
                    break;
            }
            return params;
        },
        async openModel() {

            this.isLoading = true;
            this.ApivalidationMessage = '';
            var apiResponseFlg = true;

            // バリデーションチェック
            this.validationCheck();
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            // radioボタンを取得
            var radioButtons = document.getElementsByName( "checkdis" ) ;

            // 選択状態の値を取得
            var checkedValue = ""
            for (var i=0; i < radioButtons.length; i++) {
                if ( radioButtons[i].checked ) {
                    checkedValue = radioButtons[i].value ;
                    break ;
                }
            }
            if ( checkedValue === "" ) {
                // 未選択状態
                checkedValue = false
            }

            if (this.viewtype == 'ImCheck') {
                // request作成
                var requestBodyImCheck = {
                    cooking_check_page_id: this.foodGroupSetting.cookingCheckPageId,
                    upper_button_name: this.foodGroupSetting.upperButtonName,
                    lower_button_name: this.foodGroupSetting.lowerButtonName,
                    display_flg: checkedValue,
                }
                if (this.manualFile != null) {
                    requestBodyImCheck.manual_file_path = this.manualFile
                }
                if (this.informationFile != null) {
                    requestBodyImCheck.information_file_path = this.informationFile
                }

                var header_item_list = [];
                this.foodGroupSettingLists.forEach(headerItem => {
                    var header_item = {
                        cooking_header_id: headerItem.cookingCheckHeaderId,
                        cooking_header_no: headerItem.cookingCheckHeaderNo,
                        upper_button_name: headerItem.upperButtonName,
                        lower_button_name: headerItem.lowerButtonName,
                        display_flg: headerItem.displayFlg,
                    }
                    header_item_list.push(header_item);
                });
                requestBodyImCheck.headerItemList = header_item_list;
                var formRequestBodyImCheck = this.jsonToFormData(requestBodyImCheck);

                var configImCheck  = {
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    }
                }
                //重要管理項目メニュー設定更新API
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/cooking_check/' + this.foodGroupSetting.cookingCheckButtonId, formRequestBodyImCheck, configImCheck)
                    .then(response => (this.foodGroupSetting = response.data.foodGroupSetting))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                    this.foodGroupSettingData();
                    this.manualFile = null;
                    this.informationFile = null;
                    this.showContent = true;
                }
            }
            else if (this.viewtype == 'TOP') {
                // request作成
                var requestBodyTop = {
                    upper_button_name: this.checkPageSetting.upperButtonName,
                    lower_button_name: this.checkPageSetting.lowerButtonName,
                    display_flg: checkedValue,
                }
                if (this.manualFile != null) {
                    requestBodyTop.manual_file_path = this.manualFile
                }
                if (this.informationFile != null) {
                    requestBodyTop.information_file_path = this.informationFile
                }
                if (this.bottunid=== 3) {
                    if(this.checkPageSetting.healthCheckPageSettings.checkAlert != null) {
                        requestBodyTop.check_alert = this.checkPageSetting.healthCheckPageSettings.checkAlert
                    }
                }
                var formRequestBodyTop = this.jsonToFormData(requestBodyTop);

                var configTop = {
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    }
                }
                //メニューボタン設定更新API
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/' + this.id,  formRequestBodyTop, configTop)
                    .then(response => (this.checkPageSetting = response.data))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                    this.manualFile = null;
                    this.informationFile = null;
                    this.showContent = true;
                }
            }
            else {
                // dailyMenu更新処理
                var topButtonId = this.menuid

                // freeCommentRadioボタンを取得
                var freeRadioButtons = document.getElementsByName( "freecheckdis" ) ;

                // 選択状態の値を取得
                var freeCommentCheckedValue = ""
                for (var k=0; k < freeRadioButtons.length; k++) {
                    if ( freeRadioButtons[k].checked ) {
                        freeCommentCheckedValue = freeRadioButtons[k].value ;
                        break ;
                    }
                }
                if ( freeCommentCheckedValue === "" ) {
                    // 未選択状態
                    freeCommentCheckedValue = false
                }
                // request作成
                var requestBody = {
                    upper_button_name: this.checkPageSetting.upperButtonName,
                    lower_button_name: this.checkPageSetting.lowerButtonName,
                    daily_check_button_id: this.id,
                    daily_check_button_name: this.checkPageSetting.dailyCheckButtonName,
                    display_flg: checkedValue,
                    free_comment_flg: freeCommentCheckedValue,
                }
                //メニューボタン設定更新API
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/' + topButtonId, requestBody)
                    .then(response => (this.checkPageSetting = response.data))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                    this.showContent = true;
                }
            }

        },
        closeModel() {
            this.showContent = false;
            this.$refs.manual.value = '';
            this.$refs.information.value = '';
        },
        cancel(){
            this.$router.push({name: 'manageCheckMenuList'});
        },
        openDeleteModal(fileType){
            this.showDeleteContent1 = true;
            switch(fileType) {
                case 1:
                    this.deleteFileName = "マニュアル";
                    this.deleteFileType = 'manual';
                    break;
                case 2:
                    this.deleteFileName = "インフォメーション";
                    this.deleteFileType = 'information';
                    break;
            }
        },
        async deleteFile() {
            this.showDeleteContent1 = false;
            this.isLoading = true;
            this.apivalidationMessage = '';

            let requestBody = {
                file_type: this.deleteFileType
            };
            let formRequestBody = this.jsonToFormData(requestBody);

            // 各画面のファイル削除API呼び出し
            let url = this.$apiEndpoint + 'manage/brand/' + this.brandId;
            if (this.viewtype === 'TOP' && this.bottunid === 3) {
                url += '/menu/' + this.id + '/deleteFile';
            } else if (this.viewtype === 'ImCheck') {
                url += '/cooking_check/' + this.foodGroupSetting.cookingCheckButtonId + '/deleteFile';
            }

            await this.$axios
                .post(url, formRequestBody)
                .then(response => {
                    switch (this.deleteFileType) {
                        case 'manual':
                            if (this.viewtype === 'TOP' && this.bottunid === 3) {
                                this.checkPageSetting.healthCheckPageSettings.manualFilePath = response.data.filePath;
                            } else if (this.viewtype === 'ImCheck') {
                                this.foodGroupSetting.manualFilePath = response.data.filePath;
                            }
                            break;
                        case 'information':
                            if (this.viewtype === 'TOP' && this.bottunid === 3) {
                                this.checkPageSetting.healthCheckPageSettings.informationFilePath = response.data.filePath;
                            } else if (this.viewtype === 'ImCheck') {
                                this.foodGroupSetting.informationFilePath = response.data.filePath;
                            }
                            break;
                    }
                    this.showDeleteContent2 = true;
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.apivalidationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> (this.isLoading = false));
        },
        closeDeleteModal1() {
            this.showDeleteContent1 = false;
        },
        closeDeleteModal2(){
            this.showDeleteContent2 = false;
        },
        //〇×ボタン押下時のlist書き換え用メソッド
        clickChech:function (event,index) {
            //ボタン押下時のクリック制御
            var buttonCheckList = this.foodGroupSettingLists[index];
            switch (buttonCheckList.displayFlg) {
                case 1:
                    buttonCheckList.displayFlg = 0;
                    break;
                case 0:
                    buttonCheckList.displayFlg = 1;
                    break;
                case null:
                    buttonCheckList.displayFlg = 1;
                    break;
            }
            this.foodGroupSettingLists.splice(index,1,buttonCheckList);
        },
        dailySettingData:function(){

            // デイリーデータの表示っデータを成形
            let itemList = [];
            for(var k = 0 ; k < 20 ; k++){
                var indexList = new Object();
                var settingFlg = false
                this.dailyCheckSettingLists = [];
                for( var i=0 ; i < this.checkPageSetting.dailyCheckPageSettings.length ; i++){
                    if(this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageNo == (k + 1)){
                        indexList['dailyCheckPageId']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageId;
                        indexList['dailyCheckPageNo']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageNo;
                        indexList['dailyCheckPageName']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageName;
                        indexList['manualFilePath']  = this.checkPageSetting.dailyCheckPageSettings[i].manualFilePath;
                        indexList['informationFilePath']  = this.checkPageSetting.dailyCheckPageSettings[i].informationFilePath;
                        indexList['displayFlg']  = this.checkPageSetting.dailyCheckPageSettings[i].displayFlg;
                        indexList['displayStr']  = this.checkPageSetting.dailyCheckPageSettings[i].displayStr;
                        indexList['dailyCheckItemCount']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckItemCount;
                        settingFlg = true;
                        break;
                    }
                }
                if(settingFlg == false){
                    indexList['dailyCheckPageId']  = null;
                    indexList['dailyCheckPageNo']  = k + 1;
                    indexList['dailyCheckPageName']  = '';
                    indexList['manualFilePath']  = '';
                    indexList['informationFilePath']  = '';
                    indexList['displayFlg']  = null;
                    indexList['displayStr']  = '';
                    indexList['dailyCheckItemCount']  = 0;
                }
                itemList.push(indexList);
            }
            this.dailyCheckSettingLists = itemList;
        },
        foodGroupSettingData:function(){

            let itemList = [];
            for(var k = 0; k < this.foodGroupSetting.headerItemList.length; k++){
                var indexList = new Object();
                indexList['itemId'] = k+1;
                indexList['cookingCheckHeaderId']  = this.foodGroupSetting.headerItemList[k].cookingCheckHeaderId;
                indexList['cookingCheckHeaderNo']  = this.foodGroupSetting.headerItemList[k].cookingCheckHeaderNo;
                indexList['upperButtonName']  = this.foodGroupSetting.headerItemList[k].upperButtonName;
                indexList['lowerButtonName']  = this.foodGroupSetting.headerItemList[k].lowerButtonName;
                indexList['displayOrder']  = this.foodGroupSetting.headerItemList[k].displayOrder;
                indexList['displayFlg']  = this.foodGroupSetting.headerItemList[k].displayFlg;

                if (indexList['upperButtonName'] === '　') {
                    indexList['upperButtonName'] = ''
                }

                if (indexList['lowerButtonName'] === '　') {
                    indexList['lowerButtonName'] = ''
                }
                itemList.push(indexList);
            }
            this.foodGroupSettingLists = [];
            this.foodGroupSettingLists = itemList;
        },
        getCurrentTime() {
            // 当日日付をyyyymmddhhmmssで返却
            var now = new Date();
            var res = now.getFullYear() +
                      this.padZero(now.getMonth() + 1) +
                      this.padZero(now.getDate()) +
                      this.padZero(now.getHours()) +
                      this.padZero(now.getMinutes()) +
                      this.padZero(now.getSeconds());
            return res;
        },
        padZero(num) {
            //先頭ゼロ付加
            var result;
            if (num < 10) {
                result = "0" + num;
            } else {
                result = "" + num;
            }
            return result;
        },
        selectManualFiles:function(event) {
            this.validation.manualFilePathResult = '';
            this.manualFile = null;
            let files = event.target.files[0];
            this.addFormFlg = true;

            // ファイル名の長さをチェック
            if(String(files['name']).length > 260){
                this.validation.manualFilePathResult = "ファイル名(拡張子を含む)は、260桁以内で入力してください。";
                this.addFormFlg = false;
                this.scrollTop();
                return null;
            }

            this.manualFile = files;
        },
        selectInfoFiles:function(event) {
            this.validation.informationFilePathResult = '';
            this.informationFile = null;
            let files = event.target.files[0];
            this.addFormFlg = true;

            // ファイル名の長さをチェック
            if(String(files['name']).length > 260){
                this.validation.informationFilePathResult = "ファイル名(拡張子を含む)は、260桁以内で入力してください。";
                this.addFormFlg = false;
                this.scrollTop();
                return null;
            }

            this.informationFile = files;
        },
        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
            }
        },
        jsonToFormData(data) {
            const formData = new FormData();

            this.buildFormData(formData, data);

            return formData;
        },
        setDailyCheckSetting(id,no) {
            var dailyCheckSetting = {
                id: id,
                no: no,
            }
            this.$store.dispatch('checkPage/setDailyCheckSetting', dailyCheckSetting);
        },
        validationCheck(){

            this.addFormFlg = true;

            //エラー内容初期化
            this.clearError();

            // 必須チェック
            if(this.checkPageSetting.displayFlg == 1 || this.foodGroupSetting.displayFlg == 1){
                // ボタン名称テキスト
                if((this.viewtype== 'day1' || this.viewtype== 'day2') && !this.checkPageSetting.dailyCheckButtonName){
                    this.validation.buttonNameResult="ボタン名称を入力してください。"
                    this.addFormFlg = false;
                }
                // ボタン名称(上段)
                if(this.viewtype== 'TOP' && !this.checkPageSetting.upperButtonName){
                    this.validation.upperButtonNameResult="ボタン名称(上段)を入力してください。"
                    this.addFormFlg = false;
                }
                if(this.viewtype== 'ImCheck' && !this.foodGroupSetting.upperButtonName){
                    this.validation.upperButtonNameResult="ボタン名称(上段)を入力してください。"
                    this.addFormFlg = false;
                }

                // ボタン名称(下段)
                if(this.viewtype== 'TOP' && !this.checkPageSetting.lowerButtonName){
                    this.validation.lowerButtonNameResult="ボタン名称(下段)を入力してください。"
                    this.addFormFlg = false;
                }
                if(this.viewtype== 'ImCheck' && !this.foodGroupSetting.lowerButtonName){
                    this.validation.lowerButtonNameResult="ボタン名称(下段)を入力してください。"
                    this.addFormFlg = false;
                }

                // 上段ヘッダー名
                if(this.bottunid== 4 || this.bottunid== 5){
                    for(var i = 0 ; i < this.foodGroupSettingLists.length ; i++) {
                        if (! this.foodGroupSettingLists[i].displayFlg) {
                            continue
                        }
                        if (this.bottunid== 4 && (this.foodGroupSettingLists[i].itemId > 20 && this.foodGroupSettingLists[i].itemId < 32)) {
                            if (!this.foodGroupSettingLists[i].upperButtonName) {
                                this.validation.headerSettingResult = "ヘッダー上段を入力してください。"
                                this.addFormFlg = false;
                                break;
                            }
                        }

                        if(this.bottunid== 5 && (this.foodGroupSettingLists[i].itemId > 32 && this.foodGroupSettingLists[i].itemId < 42)) {
                            if (!this.foodGroupSettingLists[i].upperButtonName) {
                                if (this.foodGroupSettingLists[i].displayFlg) {
                                    this.validation.headerSettingResult="ヘッダー上段を入力してください。"
                                    this.addFormFlg = false;
                                    break;
                                }
                            }
                        }
                    }
                }

                // 下段ヘッダー名
                for(var k = 0 ; k < this.foodGroupSettingLists.length ; k++){
                    if (!this.foodGroupSettingLists[k].lowerButtonName) {
                        if (this.foodGroupSettingLists[k].displayFlg) {
                            this.validation.headerSettingResult = "ヘッダー下段を入力してください。"
                            this.addFormFlg = false;
                            break;
                        } else {
                            // 空文字やスペースがnullで送られてしまうので全角スペースを入れる
                            this.foodGroupSettingLists[k].lowerButtonName = '　'
                        }
                    }
                }
            }

            // 表示設定
            if((this.viewtype== 'TOP' || this.viewtype== 'day1' || this.viewtype== 'day2') && this.checkPageSetting.displayFlg == null){
                this.validation.displayFlgResult="表示設定を入力してください。"
                this.addFormFlg = false;
            }
            if(this.viewtype== 'ImCheck' && this.foodGroupSetting.displayFlg == null){
                this.validation.displayFlgResult="表示設定を入力してください。"
                this.addFormFlg = false;
            }

            // フリーコメント表示設定
            if((this.viewtype== 'day1' || this.viewtype== 'day2') && this.checkPageSetting.freeCommentFlg == null ){
                this.validation.freeCommentFlgResult="フリーコメント表示設定を入力してください。"
                this.addFormFlg = false;
            }

            //チェックアラート設定
            if(this.viewtype=== 'TOP' && this.bottunid=== 3) {
                if (this.checkPageSetting.healthCheckPageSettings.checkAlert == null) {
                    this.validation.checkAlertResult = "チェックアラート設定を入力してください。"
                    this.addFormFlg = false;
                }

                if(this.checkPageSetting.healthCheckPageSettings.checkAlert == 1 && this.checkPageSetting.displayFlg == 0) {
                    this.validation.checkAlertResult = "表示設定が非表示の場合は、チェックアラートは設定できません。"
                    this.addFormFlg = false;
                }
            }

            // 桁数チェック
            // ボタン名称 30
            if((this.viewtype== 'day1' || this.viewtype== 'day2') && String(this.checkPageSetting.dailyCheckButtonName).length > 30
                && this.validation.buttonNameResult ==""){
                this.validation.buttonNameResult="ボタン名称は30桁以内で入力してください。"
                this.addFormFlg = false;
            }
            // ボタン名称(上段) 30
            if(this.viewtype== 'TOP' && String(this.checkPageSetting.upperButtonName).length > 30
                && this.validation.upperButtonNameResult ==""){
                this.validation.upperButtonNameResult="ボタン名称(上段)は30桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(this.viewtype== 'ImCheck' && String(this.foodGroupSetting.upperButtonName).length > 30
                && this.validation.upperButtonNameResult ==""){
                this.validation.upperButtonNameResult="ボタン名称(上段)は30桁以内で入力してください。"
                this.addFormFlg = false;
            }

            // ボタン名称(下段)
            if(this.viewtype== 'TOP' && String(this.checkPageSetting.lowerButtonName).length > 22
                && this.validation.lowerButtonNameResult ==""){
                this.validation.lowerButtonNameResult="ボタン名称(下段)は22桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(this.viewtype== 'ImCheck' && String(this.foodGroupSetting.lowerButtonName).length > 22
                && this.validation.lowerButtonNameResult ==""){
                this.validation.lowerButtonNameResult="ボタン名称(下段)は22桁以内で入力してください。"
                this.addFormFlg = false;
            }

            // ヘッダー上段の
            if(this.bottunid== 4 || this.bottunid== 5) {
                for (var L = 0; L < this.foodGroupSettingLists.length; L++) {
                    if(String(this.foodGroupSettingLists[L].upperButtonName).length > 30 && this.validation.headerSettingResult ==""){
                        this.validation.headerSettingResult="ヘッダー上段は30桁以内で入力してください。"
                        this.addFormFlg = false;
                        break;
                    }
                }
            }

            // ヘッダー下段
            for(var p = 0 ; p < this.foodGroupSettingLists.length ; p++){
                if(String(this.foodGroupSettingLists[p].lowerButtonName).length > 30 && this.validation.headerSettingResult ==""){
                    this.validation.headerSettingResult="ヘッダー下段は30桁以内で入力してください。"
                    this.addFormFlg = false;
                    break;
                }
            }
        },
        clearError(){
            //メッセージ初期化
            this.validation.displayFlgResult = "";
            this.validation.buttonNameResult = "";
            this.validation.upperButtonNameResult = "";
            this.validation.lowerButtonNameResult = "";
            this.validation.manualFilePathResult = "";
            this.validation.informationFilePathResult = "";
            this.validation.freeCommentFlgResult = "";
            this.validation.headerSettingResult = "";
            this.validation.checkAlertResult = "";
        },
        chengeHeaderUpper(event,buttonId,itemId){
            var textValue= event.target.value;
            if(buttonId == 4 && itemId == 21 ){
                for (var no4UpperCount1 = 0; no4UpperCount1 < this.foodGroupSettingLists.length; no4UpperCount1++) {
                    if([22,23,24,25].includes(this.foodGroupSettingLists[no4UpperCount1].itemId)){
                        this.foodGroupSettingLists[no4UpperCount1].upperButtonName = textValue;
                    }
                }
            }
            if(buttonId == 4 && itemId == 27 ){
                for (var no4UpperCount2 = 0; no4UpperCount2 < this.foodGroupSettingLists.length; no4UpperCount2++) {
                    if([28,29,30,31].includes(this.foodGroupSettingLists[no4UpperCount2].itemId)){
                        this.foodGroupSettingLists[no4UpperCount2].upperButtonName = textValue;
                    }
                }
            }
            if(buttonId == 5 && itemId == 33 ){
                for (var no5UpperCount1 = 0; no5UpperCount1 < this.foodGroupSettingLists.length; no5UpperCount1++) {
                    if([34,35,36,37].includes(this.foodGroupSettingLists[no5UpperCount1].itemId)){
                        this.foodGroupSettingLists[no5UpperCount1].upperButtonName = textValue;
                    }
                }
            }
            if(buttonId == 5 && itemId == 39 ){
                for (var no5UpperCount2 = 0; no5UpperCount2 < this.foodGroupSettingLists.length; no5UpperCount2++) {
                    if([40,41].includes(this.foodGroupSettingLists[no5UpperCount2].itemId)){
                        this.foodGroupSettingLists[no5UpperCount2].upperButtonName = textValue;
                    }
                }
            }
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>